var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import PropTypes from "prop-types";
import { t } from "ttag";
import styled from "@emotion/styled";
import Icon from "metabase/components/Icon";
import LoadingSpinner from "metabase/components/LoadingSpinner";
import SelectList from "metabase/components/SelectList";
import { color } from "metabase/lib/colors";
import { space } from "metabase/styled-components/theme";
export const DataBucketIcon = styled(Icon)`
  margin-top: 2px;
  color: ${color("text-dark")} !important;
`;
export const DataBucketDescription = styled.span`
  font-weight: bold;
  font-size: 12px;
`;
export const PickerSpinner = styled(LoadingSpinner)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${color("brand")};
  margin-left: 0.5rem;
`;
const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const BackButtonLabel = styled.span`
  font-size: 16px;
  color: ${color("text-dark")};

  margin-left: ${space(1)};

  overflow-wrap: anywhere;
  word-break: break-word;
  word-wrap: anywhere;

  :hover {
    color: ${color("brand")};
  }
`;
export function RawDataBackButton() {
  return /* @__PURE__ */ _jsx(BackButtonContainer, null, /* @__PURE__ */ _jsx(Icon, {
    name: "chevronleft",
    size: 16
  }), /* @__PURE__ */ _jsx(BackButtonLabel, null, t`Raw Data`));
}
export const DataBucketList = styled(SelectList)`
  width: 300px;
  padding: ${space(0)} ${space(1)} 12px ${space(1)};
`;
const DataBucketListItemIcon = styled(Icon)`
  color: ${color("text-dark")};
`;
const DataBucketTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;
const DataBucketListItemTitle = styled.span`
  color: ${color("text-dark")};
  font-weight: 700;
  font-size: 14px;
  margin-left: ${space(1)};
`;
const DataBucketListItemDescriptionContainer = styled.div`
  margin-top: ${space(0)};
`;
const DataBucketListItemDescription = styled.span`
  color: ${color("text-light")};
  font-weight: 700;
  font-size: 12px;
`;
const DataBucketListItemContainer = styled(SelectList.BaseItem)`
  &:hover {
    ${DataBucketListItemIcon},
    ${DataBucketListItemTitle},
    ${DataBucketListItemDescription} {
      color: ${color("text-white")};
    }
  }
`;
DataBucketListItem.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};
export function DataBucketListItem(props) {
  const { name, icon, description } = props;
  return /* @__PURE__ */ _jsx(DataBucketListItemContainer, __spreadValues({}, props), /* @__PURE__ */ _jsx(DataBucketTitleContainer, null, /* @__PURE__ */ _jsx(DataBucketListItemIcon, {
    name: icon,
    size: 18
  }), /* @__PURE__ */ _jsx(DataBucketListItemTitle, null, name)), /* @__PURE__ */ _jsx(DataBucketListItemDescriptionContainer, null, /* @__PURE__ */ _jsx(DataBucketListItemDescription, null, description)));
}
export const CollectionDatasetSelectList = styled(SelectList)`
  width: 300px;
  max-width: 300px;
  padding: 0.5rem;
`;
CollectionDatasetSelectList.Item = SelectList.Item;
export const CollectionDatasetAllDataLink = styled(SelectList.BaseItem)`
  padding: 0.5rem;

  color: ${color("text-light")};
  font-weight: bold;
  cursor: pointer;

  :hover {
    color: ${color("brand")};
  }
`;
CollectionDatasetAllDataLink.Content = styled.span`
  display: flex;
  align-items: center;

  .Icon {
    margin-left: ${space(0)};
  }
`;
export const EmptyStateContainer = styled.div`
  width: 300px;
  padding: 80px 60px;
`;
